import { Component, Input } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';

@Component({
  selector: 'app-item-tiny-task',
  template: `
    <div class="row">
      <div class="col-md-5">
        <p class="mb-0" style="font-size: 17px;">{{ task.category }}</p>
        <p class="mb-0" style="font-size: 14px;">Fecha</p>
        <p class="mb-0">{{ task.due_date | date: 'dd/MM/yy' }} {{ task.due_time | date: 'HH:mm'}}</p>
      </div>
      <div class="col-md-4">
        <p class="mb-0" *ngIf="task.settlement">{{ task.settlement }} - {{ task.building }}</p>
      </div>
      <div class="col-md-3 text-end">
        <p class="badge mb-0" [ngStyle]="{ background: priority[task.priority-1].color}">{{ priority[task.priority-1].name }}</p>
        <p class="mb-0">{{ status[task.status-1].name }}</p>
      </div>

      <!-- button class="btn btn-outline-primary text-end" routerLink="{{task.id}}">
        <fa-icon [icon]="faEdit" size="1x"></fa-icon>
        Editar
      </!-->
      <!-- button class="btn btn-link text-end">
        <fa-icon [icon]="faTrashAlt" size="1x" class="text-danger"></fa-icon>
      </!-->
    </div>
  `,
  styleUrls: []
})
export class ItemTinyTaskComponent {
  @Input() task: any = {};

  priority: any = [
    { id: 1, name: 'Baja', color: '#219C90' },
    { id: 2, name: 'Media', color: '#E9B824' },
    { id: 3, name: 'Alta', color: '#EE9322' },
    { id: 4, name: 'Urgente', color: '#D83F31' },
  ];

  status: any = [
    { id: 1, name: 'Pendiente' },
    { id: 2, name: 'En proceso' },
    { id: 3, name: 'Completada' },
    { id: 4, name: 'Cancelada' },
  ];

  constructor(
    private store: SettlementsService
  ) { }

  ngOnInit(): void {
    if (!this.task) return;
    this.store.getTaskCategory(this.task.task_category_id).subscribe((category: any) => {
      this.task.category = category.name;
    });

    if (this.task.settlement_id) {
      this.store.getSettlement(this.task.settlement_id).subscribe((settlement: any) => {
        this.task.settlement = settlement.name;
      });
    }

    if (this.task.building_id) {
      this.store.getBuilding(this.task.building_id).subscribe((building: any) => {
        this.task.building = building.name;
      });
    }
  }
}
